/**
 * Documents API Service
 *
 * Handles organization documents (PDFs, videos, etc.)
 * Endpoints: GET /api/v1/documents, GET /api/v1/documents/{id}/access
 */

import api from "../client";
import { ENDPOINTS } from "../endpoints";
import type { Document, DocumentAccessResponse } from "../types/documents";

export const documentsApi = {
  /**
   * List organization documents
   * GET /api/v1/documents
   */
  listDocuments: async (): Promise<Document[]> => {
    return api.get<Document[]>(ENDPOINTS.DOCUMENTS);
  },

  /**
   * Get presigned access URL for a document
   * GET /api/v1/documents/{id}/access
   */
  getDocumentAccess: async (
    documentId: string
  ): Promise<DocumentAccessResponse> => {
    return api.get<DocumentAccessResponse>(
      ENDPOINTS.DOCUMENT_ACCESS(documentId)
    );
  },
};

export default documentsApi;
